import React, { useContext, useState, useEffect } from "react";
import { Dialog } from "@material-ui/core";

// Contexts
import AlertContext from "../../../../context/alert/AlertContext";
import OrderContext from "../../../../context/orders/v1/OrdersContext";

// Components
import InfoContact from "./modal/Customer/InfoContact";
import InfoShipping from "./modal/Customer/InfoShipping";
import OrderFulfillment from "./modal/Fulfillment/OrderFulfillment";
import OrderTracking from "./modal/Tracking/OrderTracking";
import OrderRefund from "./modal/Refund/OrderRefund";

const MainModal = ({
  getImage,
  currentFulfilled,
  fulfilledItems,
  unfulfilledItems,
  products,
}) => {
  const { setAlert, clearAlert, alerts } = useContext(AlertContext);
  const {
    modalOpen,
    modalFunction,
    modalValues,
    modalErrors,
    modalStates,
    setModal,
    setValues,
    setErrors,
    setModalStates,
    order,
    order_error,
    refund,
    clearRefund,
    clearOrderError,
  } = useContext(OrderContext);

  const [details, setDetails] = useState({});
  const [savedMsg, setSavedMsg] = useState(null);

  const handleClose = () => {
    // When Modal Close
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, [100]);
    setValues({});
    setErrors({});
    setModal(false, null);
    setModalStates({
      submitted: false,
      changed: false,
    });
    clearRefund();
    clearOrderError();
  };

  useEffect(() => {
    // When Modal Open
    if (modalOpen) {
      // Set Modal Size
      if (
        modalFunction === "contact_info" ||
        modalFunction === "shipping_info" ||
        modalFunction === "tracking"
      ) {
        setDetails({
          size: "sm",
        });
      } else if (
        modalFunction === "fulfillment" ||
        modalFunction === "refund"
      ) {
        setDetails({
          size: "md",
        });
      }

      // Remove Saved Message
      if (savedMsg) {
        setSavedMsg(null);
      }
    }
  }, [modalOpen, modalFunction]);

  useEffect(() => {
    // Update Successful
    if (order || refund) {
      // Calculate Total Refund
      let total_refund = 0;

      if (
        "custom_total" in modalValues &&
        parseFloat(modalValues.custom_total) > 0
      ) {
        total_refund = parseFloat(modalValues.custom_total);
      } else {
        if (refund && refund.transactions.length > 0) {
          refund.transactions.map((each) => {
            total_refund += parseFloat(each.amount);
          });
        }
      }

      let text = "";

      if (modalFunction === "contact_info") {
        text = "Contact information saved.";
      } else if (modalFunction === "shipping_info") {
        text = "Shipping address saved.";
      } else if (modalFunction === "fulfillment") {
        text = "Line items have been fulfilled.";
      } else if (modalFunction === "tracking") {
        text = "Tracking information updated.";
      } else if (modalFunction === "refund") {
        text = `Refunded ${total_refund.toFixed(2)}`;
      }

      if (modalStates.changed) {
        handleClose();
        setSavedMsg(text);
      }
    }
  }, [order, refund]);

  useEffect(() => {
    // Set Update Successful Message
    if (savedMsg) {
      setTimeout(() => {
        setAlert(savedMsg, "info");
      }, 200);
    }
  }, [savedMsg]);

  useEffect(() => {
    // Clear Alerts When Modal Open
    if (modalOpen && alerts.length > 0) {
      clearAlert();
    }
  });

  useEffect(() => {
    // Update Failed
    if (order_error) {
      setModalStates({
        submitted: false,
        changed: false,
      });

      // Shopify Validation
      if (modalFunction === "contact_info") {
        if (
          typeof order_error === "object" &&
          typeof order_error.errors === "object"
        ) {
          // Contact Info
          Object.entries(order_error.errors).map(([key, val]) => {
            modalErrors[key] = `${
              key.charAt(0).toUpperCase() + key.slice(1)
            } ${val.join()}!`;
          });
        } else if (typeof order_error === "string") {
          handleClose();
          clearAlert();
          setAlert("Changes not saved.", "danger");
        }
      }

      if (modalFunction === "shipping_info") {
        if (
          typeof order_error === "object" &&
          typeof order_error.errors === "object" &&
          order_error.errors.shipping_address
        ) {
          order_error.errors.shipping_address.map((each) => {
            if (each.includes("zip")) {
              modalErrors["zip"] = "*";
              // setErrors({ ...modalErrors, zip: "*" });
            }
          });
        }
      }

      if (modalFunction === "fulfillment") {
        if (typeof order_error === "string") {
          handleClose();
          clearAlert();
          setAlert("Line items have not been fulfilled.", "danger");
        }
      }

      if (modalFunction === "tracking") {
        if (typeof order_error.errors === "string") {
          handleClose();
          clearAlert();
          setAlert(order_error.errors, "danger");
        }
      }

      if (modalFunction === "refund") {
        handleClose();
        clearAlert();

        // if (order_error === "Unavailable Shop") {
        //   setAlert(order_error, "danger");
        // }

        if (order_error) {
          setAlert(order_error, "danger");
        }
      }

      setErrors(modalErrors);
    }
  }, [order_error]);

  return (
    modalOpen && (
      <Dialog
        disableBackdropClick
        fullWidth
        maxWidth={details.size}
        open={modalOpen}
        onClose={handleClose}
      >
        <InfoContact handleClose={handleClose} />{" "}
        <InfoShipping handleClose={handleClose} />{" "}
        <OrderFulfillment
          handleClose={handleClose}
          getImage={getImage}
          unfulfilledItems={unfulfilledItems}
          products={products}
        />{" "}
        <OrderTracking
          handleClose={handleClose}
          currentFulfilled={currentFulfilled}
        />{" "}
        <OrderRefund
          handleClose={handleClose}
          getImage={getImage}
          fulfilledItems={fulfilledItems}
          unfulfilledItems={unfulfilledItems}
          products={products}
        />{" "}
      </Dialog>
    )
  );
};

export default MainModal;
